<template>
<div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/pages/404.svg" width="75%" alt="graphic-404" class="mx-auto mb-4 max-w-full">
        <!-- <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">404 - UPPSSS!!!</h1> -->
        <!-- <h3 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">Página no encontrada!</h3> -->
        <h5 class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inversef">La página que intentas acceder no está disponible en este momento. Sentimos los inconvenientes que esto pueda causar.</h5>
        <vs-button size="large" @click="$router.go(-1)">Volver</vs-button>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
Vue
</script>
